import React, { Component } from 'react';

import { Link } from "react-router-dom";

import { Row, Col} from "antd";

class HomeMoneyProtection extends Component { 
    constructor(props) {
        super();
        this.state = {
        }
    }

    renderMoneyBlockNums = () => {

        const moneyProtectionsList = [];

        for(let i = 0; i < this.props.money_protection_blocks.length; i++) {
        
            let key = 'mpn_'+i;
            let link = this.props.money_protection_blocks[i].link;

            moneyProtectionsList.push(
                <div className="block" key={key}>
                    <span className="text">{i + 1}</span>
                </div>
            );
        }
        return moneyProtectionsList;
    }

    renderMoneyBlocks = () => {

        if(this.props.money_protection_blocks.length > 0){

            return this.props.money_protection_blocks.map((_block, index) => {

                return (
                    <Col span={8} key={`mp_${index}`}>
                        <div className='justify-center vertical p-30'>
                            <div className="img-block" dangerouslySetInnerHTML={{ __html: _block.icon }} />
                            <div className="block-title mt-20 fw-b c-b fs-20">{_block.title}</div>
                            <span className="block-text mt-10 c-b fs-16">{_block.text}</span>
                            <Link to={_block.link} className="read-more mt-20"><i className="ico blue-arrow"></i></Link>
                        </div>
                    </Col>
                )
            })
        }
    }

    render () {

        return (

            <div className="money-protection text-center">
                <div className="container">
                    <div className="money-protection-block">
                        <div className="small-heading txt-uppercase">{this.props.money_protection.small_text}</div>
                        <div className="heading">{this.props.money_protection.title}</div>
                        <div className="text">{this.props.money_protection.text}</div>

                        {/* <div className="circle-blocks">
                            {this.renderMoneyBlockNums()}
                        </div> */}
                        <div className="blocks">

                            <Row gutter={24}>

                                {this.renderMoneyBlocks()}
                            </Row>
                            
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default HomeMoneyProtection;